// src/pages/AboutUs.js
import React, { useState, useEffect } from "react";
import "../index.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from "axios";

const AboutUs = () => {
  const [aboutData, setAboutData] = useState({
    about_text: "",
  });
 const [logos, setLogos] = useState([]);
  const [loading, setLoading] = useState(true);

  
useEffect(() => {
  axios.get("https://online.funforay.com/admin/public/api/logos")
    .then((res) => {
      console.log("API RESPONSE:", res.data); // 👈 ADD THIS

      if (res.data.status) {
        setLogos(res.data.data);
      }
    })
    .catch((err) => {
      console.log("API ERROR:", err);
    });
}, []);
  // Fetch About Data from API
  useEffect(() => {
    fetch("https://online.funforay.com/admin/api/settings")
      .then((res) => res.json())
      .then((data) => {
        if (data.success && data.data) {
          setAboutData({
            about_text: data.data.about_us, // ⭐ THIS IS FROM DB
          });
        }
      })
      .finally(() => setLoading(false))
      .catch(() => console.log("Failed to load About Info"));
  }, []);

  return (
    <>
      {/* ======= Banner Section ======= */}
      {/* <section className="contact-banner">
        <h1 style={{ fontSize: "48px", fontWeight: "700" }}>About Us</h1>
      </section> */}

      {/* ======= About Section ======= */}
      <section className="about-section">
        <div className="container about-row">
          <div className="about-text">
            <h1 className="gallery_title">About Us</h1>

            {/* ⭐ Load API HTML content */}
            {loading ? (
              <p>Loading...</p>
            ) : (
              <div
                dangerouslySetInnerHTML={{ __html: aboutData.about_text }}
              />
            )}
          </div>
        </div>
      </section>

      {/* ======= Partnership Section ======= */}
       <section className='client_logos'>
           <Slider
             dots={false}
             infinite={true}
             slidesToShow={5}
             slidesToScroll={1}
             autoplay={true}
             autoplaySpeed={1500}
             arrows={false}
             pauseOnHover={false}
             responsive={[
               { breakpoint: 1024, settings: { slidesToShow: 4 } },
               { breakpoint: 768, settings: { slidesToShow: 2 } },
               { breakpoint: 480, settings: { slidesToShow: 1 } }
             ]}
           >
             {logos.map((logo) => (
               <div key={logo.id}>
                 <img src={logo.image} alt="Client Logo" />
               </div>
             ))}
           </Slider>
         </section>
    </>
  );
};

export default AboutUs;
